export function WarningIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="100%" height="100%" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M0.833008 17.9166H19.1663L9.99967 2.08325L0.833008 17.9166ZM10.833 15.4166H9.16634V13.7499H10.833V15.4166ZM10.833 12.0833H9.16634V8.74992H10.833V12.0833Z"
        fill="#E21643"
      />
    </svg>
  )
}
